export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9290.bf8bc4ae.jpg";